export default __webpack_public_path__ + "static/media/clear.604f17ae.svg";